<template>
	<div class="billing-popup">
		<div class="billing-popup-body">
			<div class="billing-popup--title">{{ t('billing.activate_simple_premium') }}</div>

			<div class="billing-popup-product product">
				<div class="product--label">{{ props.product.web_name || 'Simple Premium' }}</div>
				<div class="product--price">{{ props.product?.localized_price }}</div>
			</div>

			<div class="billing-popup-tabs">
				<Tabs v-model:active="activeTab" :path="['OnboardingPaywall', 'PaymentMethodPopup']" muted>
					<template #links>
						<TabLink target="Card">
							<img src="@/assets/paywall/billing/card.svg" alt="" />
						</TabLink>
						<TabLink target="PayPal">
							<img src="@/assets/paywall/billing/paypal.svg" alt="" />
						</TabLink>
						<TabLink target="GooglePlay">
							<img src="@/assets/paywall/billing/googleplay.svg" alt="" />
						</TabLink>
					</template>
					<template #pane>
						<TabPane name="Card">
							<StripeTab
								:isActive="activeTab == 'Card'"
								:path="['OnboardingPaywall', 'PaymentMethodPopup']"
								@createPaymentMethod="onSubmit"
							/>
						</TabPane>
						<TabPane name="PayPal">
							<PayPalTab :isActive="activeTab == 'PayPal'" @tokenized="onSubmit" />
						</TabPane>
						<TabPane name="GooglePlay">
							<GooglePayTab :isActive="activeTab == 'GooglePlay'" @submit="onSubmit" />
						</TabPane>
					</template>
				</Tabs>
			</div>
		</div>

		<div class="billing-popup-footer">
			<Agreement v-if="showAgreement" :localizedPrice="props.product?.localized_price" :mode="mode" />
			<div class="billing-popup-action" id="billing-popup-action"></div>
		</div>
	</div>
</template>

<script setup>
import { TabLink, TabPane, Tabs } from '@/components/tabs'
import Agreement from './Agreement'
import { StripeTab, PayPalTab, GooglePayTab } from '@/modules/billing/'
import { computed, ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

const props = defineProps({
	product: {
		type: Object,
		required: true
	},
	mode: {
		type: String,
		validation: (value) => ['subscribe', 'purchase'].includes(value),
		default: 'subscribe'
	}
})
const { t } = useI18n()

const store = useStore()
const offsetTop = computed(() => store.state.offset_top + 'px')

const emits = defineEmits(['purchase'])

const activeTab = ref('Card')
const showAgreement = computed(() => ['Card', 'PayPal'].includes(activeTab.value))
const onSubmit = (data) => {
	emits('purchase', data)
}
</script>

<style lang="scss" scoped>
.billing-popup {
	height: calc(100vh - v-bind(offsetTop) - 40px);
	max-height: 100%;
	overflow-y: auto;
	display: flex;
	flex-direction: column;

	@media (min-width: 500px) and (min-height: 500px) {
		height: auto;
		max-height: initial;
	}

	&-body {
		flex: 1 0 auto;
		padding: 1.5rem 1.5rem;
	}

	&-footer {
		position: sticky;
		bottom: 0;
		background: rgb(255, 255, 255);
		background: linear-gradient(
			0deg,
			rgba(255, 255, 255, 1) 0%,
			rgba(255, 255, 255, 1) 90%,
			rgba(255, 255, 255, 0) 100%
		);
		padding: 1.5rem 1.5rem;

		@media (min-width: 500px) and (min-height: 500px) {
			position: static;
		}
	}

	&-action {
		min-height: 3.5rem;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}

	&-product {
		margin-top: 1.1rem;
	}

	&-tabs {
		margin-top: 1.5rem;
	}

	&--title {
		font-weight: 700;
		text-align: center;
		font-size: 1.6rem;
		color: #323653;
	}
}

.product {
	background: #f5f6f8;
	border-radius: 0.5rem;
	letter-spacing: 0.4px;
	color: #6a6d82;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 1.1rem;
}
</style>
